import { IApiResponse } from "../../Orchestrator/Types/Index";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IUIPreferences } from "../../Orchestrator/Types/Interface/IUIPreferences";

export async function getUIpreferences(): Promise<IApiResponse<IUIPreferences>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getUIpreferences;
    return await apiRequest<IUIPreferences>(endpoint, 'GET');
}